export default __webpack_public_path__ + "static/media/banner3-mobile.ff370090.png";